function init3DViewer(containerId, stlPath) {
  const container = document.getElementById(containerId);

  // Check if the viewer has already been initialized
  if (container.getAttribute('data-initialized') === 'true') {
    return; // Skip this container if it is already initialized
  }

  // Scene setup
  const scene = new THREE.Scene();
  scene.background = new THREE.Color(0xeeeeee);

  // Camera setup with initial placeholder aspect ratio
  const camera = new THREE.PerspectiveCamera(50, container.clientWidth / 340, 0.1, 1000);
  camera.position.set(150, 150, 150);
  camera.lookAt(0, 0, 0);

  const renderer = new THREE.WebGLRenderer({ antialias: true });
  renderer.setSize(container.clientWidth, 340); // Set initial size to container's width and 340px height
  container.appendChild(renderer.domElement);

  const controls = new THREE.OrbitControls(camera, renderer.domElement);
  controls.enableDamping = true;
  controls.dampingFactor = 0.05;
  controls.minDistance = 50;
  controls.maxDistance = 500;

  const ambientLight = new THREE.AmbientLight(0x404040, 2);
  scene.add(ambientLight);

  const directionalLight = new THREE.DirectionalLight(0xffffff, 1);
  directionalLight.position.set(100, 100, 100);
  scene.add(directionalLight);

  // Load the STL file
  const loader = new THREE.STLLoader();
  loader.load(stlPath, function (geometry) {
    const material = new THREE.MeshPhongMaterial({ color: 0x606060, specular: 0x111111, shininess: 200 });
    const mesh = new THREE.Mesh(geometry, material);

    geometry.computeBoundingBox();
    const center = new THREE.Vector3();
    geometry.boundingBox.getCenter(center);
    mesh.position.sub(center);

    scene.add(mesh);

    // Calculate the size of the object and adjust the camera position
    const size = new THREE.Vector3();
    geometry.boundingBox.getSize(size);
    const maxDim = Math.max(size.x, size.y, size.z);

    // Set a closer camera position based on the bounding box size
    const fitDistance = maxDim * 0.5;  // Smaller multiplier for closer view
    camera.position.set(0, fitDistance, fitDistance); // Move the camera closer
    camera.lookAt(0, 0, 0); // Ensure the camera is looking at the object's center

    // Update the controls to reflect the new camera position
    controls.update();
  });

  // Handle window resize to maintain the aspect ratio
  window.addEventListener('resize', function () {
    const width = container.clientWidth;
    const height = 340; // Fixed height
    renderer.setSize(width, height);  // Update renderer size
    camera.aspect = width / height;   // Update camera aspect ratio
    camera.updateProjectionMatrix();  // Apply the changes
  });

  function animate() {
    requestAnimationFrame(animate);
    controls.update(); // Keep updating the controls
    renderer.render(scene, camera);
  }
  animate();

  // Mark the container as initialized
  container.setAttribute('data-initialized', 'true');
}
